<template>
  <div class="statement-section invoice-section">
    <div class="section mt-4 d-flex">
      <div class="subtitle text-uppercase">
        {{ $t('invoices.single.statement.netValue') }}
      </div>
      <span class="invoice-spacer"></span>
      <div class="value big">
        {{ invoice.value | currency(invoice.currsym) }}
      </div>
    </div>
    <div class="statement-container">
      <div class="statement-header section pb-0 mt-3 d-none d-md-block">
        <b-row class="justify-content-between align-items-center">
          <b-col :cols="11">
            <b-row>
              <b-col :cols="2">{{
                $t('invoices.single.statement.refNo')
              }}</b-col>
              <b-col :cols="2">{{
                $t('invoices.single.statement.date')
              }}</b-col>
              <b-col :cols="2">{{
                $t('invoices.single.statement.transactionType')
              }}</b-col>
              <b-col :cols="2" class="text-right">{{
                $t('invoices.single.statement.credit')
              }}</b-col>
              <b-col :cols="2" class="text-right">{{
                $t('invoices.single.statement.debit')
              }}</b-col>
              <b-col :cols="2" class="text-right">{{
                $t('invoices.single.statement.outstanding')
              }}</b-col>
            </b-row>
          </b-col>
          <b-col :cols="1"></b-col>
        </b-row>
      </div>
      <div class="statement-body p-3">
        <div v-for="(item, i) in invoice.statement_data" :key="i">
          <statement-item
            :statement="item"
            :invoiceId="invoice.id"
            :currency="invoice.currsym"
            :showOutstandingBalance="true"
            :fees="invoice.fees_breakup_detailed"
            :showContent="['charges'].includes(item.type)"
          />
        </div>
        <!-- Charges Section when there is no charges in statement_data -->
        <div v-if="chargesStatement.length === 0">
          <div class="statement-data">
            <!-- Expected Charges - Desktop Starts -->
            <b-row class="align-items-center d-none d-md-flex">
              <b-col
                ><div>
                  {{ $t('invoices.single.statement.expectedChargesAsOn') }}
                </div>
                <strong
                  >{{ expectedChargesDate | formatDate('D MMMM, YYYY') }}
                  {{ ' ' }}</strong
                ><b-link
                  :to="{
                    name: 'chargesCalculator',
                    query: { invoiceId: this.$route.params.id }
                  }"
                  >&nbsp;{{
                    $t('invoices.single.statement.chooseDate')
                  }}</b-link
                ></b-col
              >
              <b-col class="text-right">{{
                totalCharges | currency(invoice.cursym)
              }}</b-col>
              <b-col :cols="2"></b-col>
              <b-col :cols="1" class="text-right">
                <b-link
                  v-b-toggle="`collapse-charges`"
                  class="view-data-link"
                  :class="{ active: !opened }"
                  v-track-click
                  @click="opened = !opened"
                  id="collapse-charges"
                >
                  <span
                    v-b-tooltip.hover
                    :title="$t('invoices.single.statement.viewDetails')"
                    v-if="opened"
                    ><b-icon-chevron-down
                  /></span>
                  <span
                    v-b-tooltip.hover
                    :title="$t('invoices.single.statement.closeDetails')"
                    v-else
                    ><b-icon-chevron-up
                  /></span>
                </b-link>
              </b-col>
            </b-row>
            <!-- Expected Charges - Desktop Ends -->
            <!-- Expected Charges - Mobile Starts -->
            <b-row class="d-flex d-md-none justify-content-between">
              <b-col :cols="'auto'" class="text-left">
                {{ $t('invoices.single.statement.expectedChargesAsOn') }}
                <div>
                  <b>{{ expectedChargesDate | formatDate('D MMMM, YYYY') }}</b>
                </div>
              </b-col>
              <b-col :cols="'auto'" class="text-right"
                ><b>{{ totalCharges | currency(invoice.cursym) }}</b></b-col
              >
            </b-row>
            <b-row class="d-flex d-md-none">
              <b-col
                :cols="'auto'"
                class="text-right position-relative mobile-stuff"
              >
                <b-link
                  v-b-toggle="`collapse-charges`"
                  class="view-data-link"
                  :class="{ active: !opened }"
                  v-track-click
                  @click="opened = !opened"
                  id="collapse-charges-mobile"
                >
                  <span
                    v-b-tooltip.hover
                    :title="$t('invoices.single.statement.viewDetails')"
                    v-if="opened"
                    ><b-icon-chevron-down
                  /></span>
                  <span
                    v-b-tooltip.hover
                    :title="$t('invoices.single.statement.closeDetails')"
                    v-else
                    ><b-icon-chevron-up
                  /></span>
                </b-link>
              </b-col>
            </b-row>
            <!-- Expected Charges - Mobile Ends -->
          </div>
          <charges-data
            :fees="invoice.fees_breakup_detailed"
            :currency="invoice.currsym"
            :opened="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import StatementItem from '@/components/common/StatementItem/'
import ChargesData from '@/components/invoices/Details/v2/ChargesData/'

export default {
  data() {
    return {
      opened: false
    }
  },
  props: ['invoice'],
  computed: {
    chargesStatement() {
      return this.invoice.statement_data.filter((statement) => {
        return statement.type === 'charges'
      })
    },
    totalCharges() {
      let arr = this.invoice.fees_breakup_detailed.map((fee) => {
        return parseFloat(fee.value)
      })
      return arr.reduce(
        (accumulator, currentValue) => accumulator + currentValue
      )
    },
    expectedChargesDate() {
      let repaymentDate = new Date(this.invoice.repayment)
      let currentDate = new Date()
      return repaymentDate > currentDate
        ? repaymentDate
        : this.$t('invoices.single.statement.today')
    }
  },
  components: {
    StatementItem,
    ChargesData
  }
}
</script>
<style lang="scss" scoped>
.mobile-stuff {
  width: 100%;
  padding: 0 5px;
  top: 10px;

  .view-data-link {
    width: 100%;
    border-radius: 0;
  }
}
</style>
